import API from "@/services/api/api.service";
import { RouteLocationNormalized } from "vue-router";

export const invitationResolver = async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    try {
        if(to.params.token === null || to.params.token === undefined || to.params.token === '') {
            console.error('INVITATION_RESOLVER_ERROR: undefined Token');
            return { name: 'Login' };
        }
    } catch(error) {
        console.error('INVITATION_RESOLVER_ERROR');
        return { name: 'Login' };
    }
}